export default "__VITE_ASSET__Cg1Nal54__"